import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import SpinnerLoader from "../Components/SpinnerLoader";

const { REACT_APP_BASE_URL } = process.env;

const ScheduleMeet = () => {
  const [currentUser, setCurrentUser] = useState({});
  const token = localStorage.getItem("token");
  const email = localStorage.getItem("urserMail");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true)

    const script = document.createElement("script");
    script.src =
      "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
    script.async = true;
    script.onload = getCurrentUser;
    script.onerror = () => {
      toast.error("Could not load the meeting scheduler.");
      setLoading(false);
    };
    document.body.appendChild(script);
    return () => {
      script.onload = null;
      script.onerror = null;
      script.remove();
    };
  }, []);

  const getCurrentUser = async () => {
    setLoading(true)
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/user`,
        {
          email: email,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCurrentUser(response?.data);
      setLoading(false)

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Could not load your meeting link.");
      setLoading(false)
    }
  };

  const meetingUrl = (currentUser?.meet_embedded || "").trim();
  // a non-URL value resolves against this app, so the iframe would load the app itself (the canvas map)
  const hasValidMeetingUrl = /^https?:\/\/\S+$/i.test(meetingUrl);

  return (
    <div className="bg-canvas-userbar h-screen md:p-10 p-2 overflow-hidden">
      {
        loading ?
          <div className="h-full w-full flex justify-center items-center ">
            <SpinnerLoader className={'max-w-20 max-h-20 text-gray-200 animate-spin fill-canvas-primary'} />
          </div> : (hasValidMeetingUrl ? (
            <iframe
              title="meeting embeded"
              className="meetings-iframe-container w-full h-screen bg-transparent overflow-hidden"
              src={meetingUrl}
            ></iframe>
          ) : (
            <h2 className="flex items-center justify-center font-outfit text-canvas-primary">
              Please add user Meeting Code URL in Profile Setting
            </h2>
          ))
      }
    </div>
  );
};

export default ScheduleMeet;
